// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZpNZ","right":"styles_right__1vJCE"};